import React from 'react';
import PropTypes from 'prop-types';
// import styles from './optionGroupStyles';

const ChooseCutoutsOptionGroup = ({ children }) => children.length > 0 && (
  <div id="ChooseCutouts" data-template="ChooseCutoutsOptionGroup" className="card-content flex-wrap-dependent-options">
    <div className="row-header">
      <div className="row-header__title">
        <div className="sui-h2-bold sui-line-clamp-unset sui-text-primary">
          Cutouts
        </div>
      </div>
    </div>
    <div className="subQuestion">
      <p>
        How many of each cutout type do you need in this countertop?
      </p>
    </div>
    <div className="flex-wrap-dependent-options dependent-options">{children}</div>
  </div>
);

ChooseCutoutsOptionGroup.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ChooseCutoutsOptionGroup;
